import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  card: {
    backgroundColor: theme.colorPalette.green_90,
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2, 6, 6),
    ...reskinStyles(theme, { backgroundColor: 'transparent' })
  },
  label: {
    color: theme.onCard.beige_25,
    fontWeight: 600,
    fontSize: 10
  },
  buttonLabel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  line: {
    margin: theme.spacing(6, 0, -7, 0)
  }
});

export default makeStyles(styles);
